import {GoCometProvider as CometProvider} from "./CometProvider/index";
import Entity from "./entity";

class Comet
{
	constructor()
	{
		this.channels = {};
		this.servers = [];
		this.currentServerIndex = 0;
		this.eventListeners = [];
		this.reconnectTimeoutDefault = 10;
		this.reconnectTimeout = this.reconnectTimeoutDefault;
		this.reconnectMaxTimeout = 120;
		this.reconnectTimeResetTimer = null;

        const updateEvent = (data) => {
            const instance = Entity.Event.getInstance(data.id);
            if (instance) {
                return;
            }

            instance.fillFrom(data);
        };
        const updateStream = (data) => {
            const instance = Entity.Event.Stream.getInstance(data.id);
            if (instance) {
                instance.fillFrom(data);
            } else {
                new Entity.Event.Stream(data);
            }
        };
        const removeStream = (id) => {
            const instance = Entity.Event.Stream.getInstance(id);
            if (instance) {
                instance.remove();
            }
        };
        const updateStreamStream = (data) => {
            new Entity.Event.Stream.Stream(data);
        };
        const updateBroadcastStreamSession = (data) => {
            const instance = Entity.Event.Stream.BroadcastSession.getInstance(data.id);
            if (instance) {
                instance.fillFrom(data);
            } else {
                new Entity.Event.Stream.BroadcastSession(data);
            }
        };

        const refreshPage = (params) => {
            let timeout = 60000 + Math.random() * 60000;
            if (params === 'now') {
                timeout = 0;
            }
            setTimeout(() => document.location.reload(), timeout)
        };

		this
			.on('update:event', updateEvent)

			.on('create:stream', updateStream)
			.on('update:stream', updateStream)
			.on('delete:stream', ({id}) => removeStream(id))

			.on('create:streams/stream', updateStreamStream)

			.on('create:broadcast/stream/session', updateBroadcastStreamSession)
			.on('update:broadcast/stream/session', updateBroadcastStreamSession)

			.on('refresh', refreshPage)
		;
	}

	join(...channelNames)
	{
		channelNames.forEach(channel => {
			this.channels[channel] = channel;
		});

		if (this.provider) {
			this.provider.join(channelNames);
		}

		return this;
	}

	leave(...channelNames)
	{
		channelNames.forEach(channel => {
			delete this.channels[channel];
		});

		if (this.provider) {
			this.provider.leave(channelNames);
		}

		return this;
	}

	on(eventName, handler)
	{
		this.eventListeners.push({
			eventName,
			handler
		});

		if (this.provider) {
			this.provider.on(eventName, handler);
		}

		return this;
	}

	arrayShuffle(array)
	{
		for (let i = array.length - 1; i > 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			[array[i], array[j]] = [array[j], array[i]];
		}
	}

	setServers(servers)
	{
		this.arrayShuffle(servers);

		this.servers = servers;
		this.currentServerIndex = 0;

		this.connect();
	}

	connect()
	{
		let host = this.servers[this.currentServerIndex];

		this.provider = new CometProvider(host);

		this.provider.on('close', () => {
			if (!this.servers[++this.currentServerIndex]) {
				this.currentServerIndex = 0;
			}
			console.warn('comet reconnect to host: ' + this.servers[this.currentServerIndex]);

			if (this.reconnectTimeResetTimer) {
				clearTimeout(this.reconnectTimeResetTimer);
			}
			this.reconnectTimeResetTimer = setTimeout(() => {
				this.reconnectTimeout = this.reconnectTimeoutDefault;
			}, this.reconnectTimeout * 2 * 1000);

			setTimeout(() => this.connect(), this.reconnectTimeout * 1000);

			this.reconnectTimeout *= 2;
			if (this.reconnectTimeout > this.reconnectMaxTimeout) {
				this.reconnectTimeout = this.reconnectMaxTimeout;
			}
		});

		this.provider.on('open', () => {
			this.provider.join(Object.keys(this.channels));

			this.eventListeners.forEach(({eventName, handler}) => {
				this.provider.on(eventName, handler);
			});
		});
	}
}

export default Comet;
